<template>
	<div ref="self">
		<div class="filter filter--main">
			<div class="filter__sect" v-for="(filterSection, index) in data.filters" :key="index" :data-mapper="filterSection.mapper">
				<div v-if="filterSection.capt" class="filter__sect-capt">
					<span  class="t-h--13">
						<span class="t--fak"><span class="t--ft">(</span>{{ filterSection.capt }}<span class="t--ft">)</span></span>
					</span>
				</div>
				<ul class="c-disc">
					<li class="filter__item" v-for="(button, index) in filterSection.items" :key="index" :data-button-index="button[0]" :data-color="button[2]">
						<button class="c-disc__unit c-disc__bullet-wrap filter__button">
							<span class="c-disc__bullet"></span>
							<span class="t-h--16 filter__txt"><span class="t--fak">{{button[1]}}</span></span>
						</button>
						<span class="filter__bar"></span>
						<span class="t-h--16 filter__count">
							<span class="t--fak"><span class="t--ft">(</span>{{ data.getCount(filterSection.mapper, index) }}<span class="t--ft">)</span></span>
						</span>
					</li>
				</ul>
			</div>
		</div>

		<div class="c-filter-panel c-filter-panel--closed i-filter-panel" :class="{'c-filter-panel--disappear': data.getHideState }">
			<button class="c-filter-panel__btn">
				<span class="c-filter-marquee c-filter-marquee--animate">
					<span class="c-filter-marquee__item">
						<span class="t-h--16"><span class="t--fak">ALL PROJECTS</span></span>
					</span>
					<span class="c-filter-marquee__item">
						<span class="t-h--16"><span class="t--fak">ALL PROJECTS</span></span>
					</span>
				</span>
			</button>
			<button class="c-filter-panel__btn-close">
				<span class="t-h--16"><span class="t--fak"><span class="t--ft">(</span>CLOSE<span class="t--ft">)</span></span></span>
			</button>
			<div class="c-filter-panel__pad">
				<div class="c-filter-panel__inner">
					<div class="filter">
						<div class="filter__sect" v-for="(filterSection, index) in data.filters" :key="index" :data-mapper="filterSection.mapper">
							<div v-if="filterSection.capt" class="filter__sect-capt">
								<span  class="t-h--13">
									<span class="t--fak"><span class="t--ft">(</span>{{ filterSection.capt }}<span class="t--ft">)</span></span>
								</span>
							</div>
							<ul class="c-disc">
								<li class="filter__item" v-for="(button, index) in filterSection.items" :key="index" :data-button-index="button[0]" :data-color="button[2]">
									<button class="c-disc__unit c-disc__bullet-wrap filter__button">
										<span class="c-disc__bullet"></span>
										<span class="t-h--16 filter__txt"><span class="t--fak">{{button[1]}}</span></span>
									</button>
									<span class="filter__bar"></span>
									<span class="t-h--16 filter__count">
										<span class="t--fak"><span class="t--ft">(</span>{{ data.getCount(filterSection.mapper, index) }}<span class="t--ft">)</span></span>
									</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as _ from 'fxjs';
import * as $ from 'fxdom';
import { ref, reactive, computed, onMounted, onBeforeUnmount, useStore } from "@/helper/vue.js";
import { gsap } from "gsap/all";
import { getData, getDataList } from "@/store/data-global.js";
import { count } from "@/store/data-workList.js";
import { stPos, setScroll } from "@/helper/gadget.js";
export default {
	setup() {
		const self = ref();
		const { state, get, commit } = useStore();
		const data = reactive({
			isSubFilterActive: false,
			getHideState: computed(() => {
				if(get["hiddenOnLoading"]) return true;
				if(!data.isSubFilterActive) return true;
				return false;
			}),
			getCount: (mapper, index) => {
				if(mapper == "ALL PROJECTS") return count.all;
				if(mapper == "Category") return count.category[index];
				if(mapper == "Tag") return count.tag[index];
			},
			filters : [
				{
					mapper: "ALL PROJECTS",
					items: [[0, "ALL PROJECTS"]]
				},
				{
					capt: "SERVICES",
					mapper: "Category",
					items: getData("work.categoryWithColor")
				},
				{
					capt: "INTERESTS",
					mapper: "Tag",
					items: getDataList("work.tag")
				}
			],
		});

		let CB_CHANGED_MQ = null;
		let CB_CLOSE_FILTER = null;

		onMounted(() => {
			// 초기화
			_.go(
				$.qsa("[data-mapper='ALL PROJECTS'] .filter__item", self.value),
				_.each($.addClass("filter__item--active"))
			);
			$.setText(data.getCount("ALL PROJECTS", 0), $.qs(".i-worklist-count"));

			// window.addEventListener("scroll", () => {
			// 	console.log(window.pageYOffset);
			// });

			_.go(
				$.qsa(".filter__button", self.value),
				_.each(item => {
					// 클릭이벤트
					item.addEventListener("click", (e) => {
						const mapper = $.attr("data-mapper", $.closest(".filter__sect", item));
						const filterItem = $.closest(".filter__item", item);
						const isPanelItem = $.closest(".c-filter-panel", item) ? true : false;
						const currentIndex = $.attr("data-button-index", filterItem);
						// 이미 선택된 아이템을 클릭한 경우
						if($.hasClass("filter__item--active", filterItem)) {
							// 그 아이템이 올프로젝트인 경우, 서브필터를 닫는 것 외에 아무 일도 하지 않는다.
							if(mapper == "ALL PROJECTS") {
								return;
							}
						}
						else {

							setScroll(state.currScroll + Math.floor($.qs(".i-worklist-head").getBoundingClientRect().y) - 50);
							setTimeout(() => {
								commit("set", { sel: "scrollDir", to: "up" });
							}, 50);

							// 기존 클래스 제거
							_.go(
								$.qsa(".filter__item--active"),
								_.each($.removeClass("filter__item--active"))
							);

							// 타겟에 클래스 추가
							_.go(
								$.qsa(`[data-mapper='${mapper}'] [data-button-index='${currentIndex}']`),
								_.each($.addClass("filter__item--active"))
							);

							// 서브 메뉴 배경색 변경
							const color = $.attr("data-color", filterItem);
							if(color) {
								$.qs(".c-filter-panel").style.setProperty("--background", "#171010");
								$.qs(".c-filter-panel").style.setProperty("--foreground", color);
							}
							else {
								$.qs(".c-filter-panel").style.removeProperty("--background");
								$.qs(".c-filter-panel").style.removeProperty("--foreground");
							}

							// 서브 메뉴 닫기
							$.addClass("c-filter-panel--closed", $.qs(".c-filter-panel"));

							// 버튼 마키 텍스트 변경
							_.go(
								$.qsa(".c-filter-marquee__item .t--fak"),
								_.each(item => {
									item.innerText = $.qs(".filter__txt .t--fak", filterItem).innerText;
								})
							);
							$.removeClass("c-filter-marquee--animate", $.qs(".c-filter-marquee"));
							setTimeout(() => {
								$.addClass("c-filter-marquee--animate", $.qs(".c-filter-marquee"));
							});

							// 카운트 및 선택 텍스트 변경
							$.setText($.qs(".filter__txt .t--fak", filterItem).innerText, $.qs(".i-worklist-capt"));
							$.setText(data.getCount(mapper, currentIndex), $.qs(".i-worklist-count"));

							// 본문 스크롤
							setTimeout(() => {
								// 스토어 값 변경
								if(mapper == "ALL PROJECTS") {
									commit("set", { sel: "workList.selectedCategory", to: -1 });
									commit("set", { sel: "workList.selectedTag", to: -1 });
								}
								else {
									const opposite = mapper == "Category" ? "Tag" : "Category";
									commit("set", { sel: `workList.selected${mapper}`, to: currentIndex });
									commit("set", { sel: `workList.selected${opposite}`, to: -1 });
								}
							}, isPanelItem ? 250 : 0); // 서브필터로 클릭한 경우 트랜지션이 완료될 때 까지 기다려준 후에 프로젝트 리스트 필터링을 해준다.
						}
					});
				})
			);

			$.qs(".c-filter-panel__btn").addEventListener("click", () => {
				$.removeClass("c-filter-panel--closed", $.qs(".c-filter-panel"));
			});

			$.qs(".c-filter-panel__btn-close").addEventListener("click", () => {
				$.addClass("c-filter-panel--closed", $.qs(".c-filter-panel"));
			});

			// 화면에 붙일 수 있게 i-canvas 밖으로 빼준다.
			$.appendTo($.qs("body"), $.qs(".c-filter-panel"));

			let subFilterTl = null;

			CB_CHANGED_MQ = () => {
				// pc -> mo, mo -> pc 구간을 넘나들 때 스크롤트리거를 새로 등록해준다.
				if(subFilterTl != null) {
					gsap.killTweensOf(subFilterTl);
					subFilterTl.scrollTrigger && subFilterTl.scrollTrigger.kill();
					subFilterTl.kill();
					subFilterTl = null;
				}

				const trigger = state.cw < 600 ? $.qs(".i-work-list") : self.value;
				const start = state.cw < 600 ? "0% 50%" : "100% 0%";

				subFilterTl = gsap.timeline({
					scrollTrigger: {
						trigger,
						start,
						endTrigger: $.qs(".c-footer"),
						end: "0% 90%",
						scrub: true,
						onToggle({ isActive }) {
							if(isActive) {
								data.isSubFilterActive = true;
							}
							else {
								data.isSubFilterActive = false;
							}
						}
					}
				});
			};

			CB_CLOSE_FILTER = () => {
				if(data.isSubFilterActive) {
					$.addClass("c-filter-panel--closed", $.qs(".c-filter-panel"));
				}
			};

			$.qs(".i-canvas").addEventListener("click", CB_CLOSE_FILTER);

			window.addEventListener("landed", CB_CHANGED_MQ);
			window.addEventListener("changed.mq", CB_CHANGED_MQ);
		});

		onBeforeUnmount(() => {
			$.qs(".i-canvas").removeEventListener("click", CB_CLOSE_FILTER);
			window.removeEventListener("landed", CB_CHANGED_MQ);
			window.removeEventListener("changed.mq", CB_CHANGED_MQ);
			$.remove($.qs(".c-filter-panel"));
		})

		return {
			self,
			data
		}
	}
}
</script>

<style scoped lang="scss">

.filter {
	width: 100%;
	&__sect-capt {
		margin-top: 32em;
		margin-bottom: 16em;
	}
	&__item {
		position: relative;
		display: flex;
		margin-top: 17em;
		&:first-child {
			margin-top: 0;
		}
		&--active {
			.c-disc__bullet:after {
				transform: translate(-50%, -50%) scale(1);
			}
		}
	}
	&__txt {
		display: inline-block;
		margin-right: 0 !important;
	}
	&__bar {
		position: relative;
		top: -3.5em;
		flex: 1;
		margin-left: 3em;
		border-bottom: solid 1px;
	}
	&__count {
		display: none;
		margin-left: 4em;
		.filter__item--active & {
			display: inline-block;
		}
	}
	&--main {
		.filter__count {
			@media screen and (min-width: 600px) and (max-width: 650px) {
				display: none !important;
			}
		}
	}
}


$defaultDuration: 0.3s;
$openDuration: 0.25s;
$beforeCloseDuration: 0.1s;
$closeDuration: 0.15s + $beforeCloseDuration;

.c-filter-panel {
	position: fixed;
	font-size: 1px;
	left: var(--outerGutter);
	bottom: var(--outerGutter);
	width: calc(100% - var(--outerGutter) * 2);
  max-width: 375em;
	height: calc(100% - var(--outerGutter) * 2);
	max-height: 633em;
	background-color: var(--foreground);
	color: var(--background);
	border-radius: 24em;
	padding: 32em 0 66em 0;
	transition: all $openDuration ease, color $defaultDuration ease, background-color $defaultDuration ease;
	z-index: 1300;
	&:after {
		content: "";
		position: absolute;
		left: 0;
		right: 0;
		bottom: 66em;
		height: 1px;
		opacity: 0.4;
		background-color: var(--background);
		transition: background-color $defaultDuration $openDuration;
	}
	.w600__ & {
		@media screen and (max-height: 700px) {
			display: none !important;
		}
	}
	.__w600 & {
		left: 8em;
		bottom: 16em;
		width: calc(100% - 16em);
		height: calc(100% - 32em);
		font-size: inherit;
		max-width: none;
		z-index: 1190;
	}
	&__btn {
		position: absolute;
    bottom: 0;
    left: 0;
    width: 144em;
    height: 54em;
    padding-left: 18em;
    padding-right: 18em;
		pointer-events: none;
		user-select: none;
	}
	&__btn-close {
		position: absolute;
		bottom: 50em;
		left: 16em;
		transform: translateY(100%);
		opacity: 1;
		visibility: visible;
		transition: all $defaultDuration $openDuration;
	}
	&__pad {
		height: 100%;
		padding-left: 16em;
		padding-right: 16em;
		transition: all $defaultDuration $openDuration, color $defaultDuration ease, background-color $defaultDuration ease;
		visibility: visible;
		opacity: 1;
		.__w600 & {
			overflow: scroll;
		}
	}
	&__inner {
		padding-bottom: 16em;
	}
	.c-disc__bullet {
		.w600__ & {
			transform: translate(-50%, -50%) scale(1);
		}
	}
	.c-disc__bullet:before {
		border-color: var(--background);
		transition: border-color $defaultDuration ease;
	}
	.c-disc__bullet:after {
		background-color: var(--background);
		transition: transform $defaultDuration cubic-bezier(0.22, 0.61, 0.36, 1), background-color $defaultDuration ease;
	}
	.filter__count {
		margin-right: 0;
	}
}

.c-filter-panel--closed {
	width: 144em !important;
	height: 54em !important;
	border-radius: 27em;
	padding: 0;
	&:after {
		background-color: transparent;
		transition: background-color $beforeCloseDuration;
	}
	.c-filter-panel__btn-close {
		transition: all $beforeCloseDuration;
		opacity: 0;
		visibility: hidden;
	}
	.c-filter-panel__btn {
		pointer-events: all;
		user-select: auto;
	}
	.c-filter-panel__pad {
		transition: all $beforeCloseDuration;
		visibility: hidden;
		opacity: 0;
	}
	.c-filter-marquee {
		visibility: visible;
		opacity: 1;
		transition: all 0s $closeDuration, color $defaultDuration ease;
	}
}

.c-filter-panel--disappear {
	transform: translateY(30em);
	opacity: 0;
	transition: transform $defaultDuration ease, opacity 0.23s ease;
	.c-filter-panel__btn {
		pointer-events: none;
		user-select: none;
	}
}

.c-filter-marquee {
	display: inline-block;
	width: 100%;
	color: var(--background);
	overflow: hidden;
	white-space: nowrap;
	visibility: hidden;
	opacity: 0;
	&__item {
		display: inline-block;
		padding-right: 15em;
	}
	&--animate {
		.c-filter-marquee__item {
			animation: marquee 3.5s linear infinite;
		}
		@keyframes marquee {
			0% { transform: translateX(0); }
			100% { transform: translateX(-100%); }
		}
	}
}

</style>